import { api_configuration } from "../../common";
import client_state_decorator = api_configuration.types.client_state.alan_api;
import ClientState = require("../state/ClientState");
import uuid = require("../state/uuid");
import { translate, TranslationKey, FormatString } from "./translate";

type MessageType = Exclude<client_state_decorator.Tmessages["type"], any[]>;
type RawBodyOptions = {
	raw_body?: string;
};
type TranslatedBodyOptions = {
	body?: TranslationKey | FormatString;
};
type Options = (TranslatedBodyOptions | RawBodyOptions) & {
	key?: string;
};

function isTranslatedBodyOptions(options: Options): options is Required<TranslatedBodyOptions> {
	return (options as TranslatedBodyOptions)?.body !== undefined;
}

function isRawBodyOptions(options: Options): options is Required<RawBodyOptions> {
	return (options as RawBodyOptions)?.raw_body !== undefined;
}

export function addMessage(type: MessageType, title: TranslationKey | FormatString, options?: Options): string {
	const message_id = options && options.key ? options.key : uuid.generate();
	let body_text: string | undefined = undefined;
	if (options !== undefined) {
		if (isTranslatedBodyOptions(options)) {
			body_text = translate(options.body);
		} else if (isRawBodyOptions(options)) {
			body_text = options.raw_body;
		}
	}
	ClientState.client_state.properties.messages.switchOnEntryExists(message_id, undefined, function () {
		ClientState.client_state.properties.messages.create(message_id, {
			type: [type, {}],
			title: translate(title),
			"has body":
				body_text === undefined
					? "no"
					: [
							"yes",
							{
								body: body_text,
							},
					  ],
		});
	});
	return message_id;
}

export function addRawMessage(type: MessageType, title: string, body: string) {
	ClientState.client_state.properties.messages.create(uuid.generate(), {
		type: [type, {}],
		title: title,
		"has body": [
			"yes",
			{
				body: body,
			},
		],
	});
}

export function removeAllMessages(): void {
	ClientState.client_state.properties.messages.forEach(function ($) {
		$.properties.type.switch({
			error: function () {
				ClientState.client_state.properties.messages.delete($.key);
			},
			warning: function () {
				ClientState.client_state.properties.messages.delete($.key);
			},
			success: function () {
				ClientState.client_state.properties.messages.delete($.key);
			},
			waiting: undefined,
		});
	});
}
export function removeMessage(id: string): void {
	ClientState.client_state.properties.messages.switchOnEntryExists(
		id,
		function () {
			ClientState.client_state.properties.messages.delete(id);
		},
		undefined
	);
}
